import { SVGAttributes } from 'react';

export const PoppyRedCircle = ({ className }: SVGAttributes<SVGSVGElement>) => (
  <svg
    className={className}
    width="85"
    height="52"
    viewBox="0 0 85 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="42.4996" cy="42.4625" r="42.4625" fill="#FC663D" />
  </svg>
);

PoppyRedCircle.displayName = 'HiringHero_PoppyRedCircle';
